import { createActionHelpers } from 'vuex-loading';
import Laroute from '../../laroute';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const pricebook = {
    id: null,
    name: null,
    outlets: [],
};

const mapPricebookToServerObject = pricebook => {
    const data = _.pick(pricebook, 'name');
    data.outlets = pricebook.outlets.map(o => o.id);

    return data;
};

const mapEntryToServerObject = p => {
    let products = [_.pick(p, ['hidden'])];
    let variants = [];

    products[0].id = p.id;

    if (p.price_type == 0) {
        variants = p.variants.map(v => {
            return {
                id: v.id,
                cost: v.override_cost,
                price: v.override_price,
                hidden: v.hidden,
            };
        });
    } else if (p.price_type == 1) {
        products[0].unit_price = p.override_unit_price;
    }

    return {
        products,
        variants,
    };
};

const state = {
    pricebook,
    original: _.cloneDeep(pricebook),
};

const getters = {
    pricebook: state => state.pricebook,
    original: state => state.original,
    products: state => state.pricebook.products,
    outlets: state => state.pricebook.outlets,
};

const mutations = {
    setPricebook(state, pricebook) {
        state.pricebook = pricebook;
        state.original = _.cloneDeep(pricebook);
    },

    setPricebookAttr(state, { key, value }) {
        state.pricebook[key] = value;
    },
};

const actions = {
    async getPricebook({ commit, dispatch }, id) {
        startLoading(dispatch, 'fetch-pricebook');
        const url = Laroute.route('franchise.inventory.pricebook.show', { id });

        const { data } = await axios.get(url);

        endLoading(dispatch, 'fetch-pricebook');
        commit('setPricebook', data);

        return data;
    },

    async createPricebook({ state, dispatch, commit }) {
        const url = Laroute.route('franchise.inventory.pricebook.store');

        startLoading(dispatch, 'save-pricebook');

        try {
            const { data } = await axios.post(
                url,
                mapPricebookToServerObject(state.pricebook),
            );
            commit('setPricebook', data);

            return data;
        } catch (e) {
            endLoading(dispatch, 'save-pricebook');
            throw e;
        }
    },

    async updatePricebook({ state, dispatch, commit }) {
        const id = state.pricebook.id;
        const url = Laroute.route('franchise.inventory.pricebook.update', {
            id,
        });

        startLoading(dispatch, 'save-pricebook');

        try {
            const { data } = await axios.patch(
                url,
                mapPricebookToServerObject(state.pricebook),
            );
            endLoading(dispatch, 'save-pricebook');
            commit('setPricebook', data);

            return data;
        } catch (e) {
            endLoading(dispatch, 'save-pricebook');
            throw e;
        }
    },

    async saveProductVariantEntry({ state, dispatch }, params) {
        const id = state.pricebook.id;
        const url = Laroute.route('franchise.inventory.pricebook.entry.save', {
            id,
        });
        startLoading(dispatch, 'save-pricebook-entry');

        try {
            const { data } = await axios.post(
                url,
                mapEntryToServerObject(params),
            );
            endLoading(dispatch, 'save-pricebook-entry');

            return { data };
        } catch (e) {
            endLoading(dispatch, 'save-pricebook-entry');
            throw e;
        }
    },

    setPricebookAttr({ commit }, { key, value }) {
        commit('setPricebookAttr', { key, value });
    },

    bulkHidePricebook({ commit, dispatch }, update) {
        startLoading(dispatch, 'save-pricebook');

        return axios
            .patch(Laroute.route('franchise.inventory.pricebook.hide'), update)
            .then(res => {
                endLoading(dispatch, 'save-pricebook');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-pricebook');
                throw err;
            });
    },

    bulkUnhidePricebook({ commit, dispatch }, update) {
        startLoading(dispatch, 'save-pricebook');

        return axios
            .patch(
                Laroute.route('franchise.inventory.pricebook.unhide'),
                update,
            )
            .then(res => {
                endLoading(dispatch, 'save-pricebook');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-pricebook');
                throw err;
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/pricebook.js